// extracted by mini-css-extract-plugin
export default {"container":"pdfPreview_container__hn-jc","pdfContainerOcr":"pdfPreview_pdfContainerOcr__HyODD"};